import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {BuildingOverviewComponent} from './building-overview.component';
import {BuildingFormComponent} from './building-form.component';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import {CustomerContactFormComponent} from '../customer/customer-contact-form.component';
import {BuildingContactFormComponent} from './building-contact-form.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'building',
    component: BuildingOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.building.pageTitle',
      scopes: ['building:read']
    }
  },
  {
    name: 'building.add',
    component: BuildingFormComponent,
    future: true,
    data: {
      pageTitle: 'states.building.add.pageTitle',
      scopes: ['building:create']
    }
  },
  {
    name: 'building.edit',
    component: BuildingFormComponent,
    future: true,
    data: {
      pageTitle: 'states.building.edit.pageTitle',
      scopes: ['building:update']
    }
  },
  {
    name: 'building.edit.contact',
    component: BuildingContactFormComponent,
    future: true,
    data: {
      pageTitle: 'states.building.edit.contact.add.pageTitle',
      scopes: ['contact:create']
    }
  },
  {
    name: 'building.edit.contact.edit',
    component: BuildingContactFormComponent,
    future: true,
    data: {
      pageTitle: 'states.building.edit.contact.edit.pageTitle',
      scopes: ['contact:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class BuildingRoutingModule {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/building/building.routes.ts